import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null); // store the entire user object here

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
      setIsLoggedIn(true);
      axios.get(`${apiBaseUrl}/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => setUser(res.data))
        .catch(err => console.error('Error fetching user info:', err));
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    setIsLoggedIn(true);
    setUser(userData); // store user object returned from login
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
